import React from 'react'
import { Button } from 'antd'
import { BigSale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import styles from './SaleSmallDetails.module.scss'
import { CustomTag, CustomTitle } from 'src/components'
import { CloudDownloadOutlined } from '@ant-design/icons'
import {
  getDateFormatted,
  getFormatedPrice,
  getBigSaleStatus,
  getBigSaleBlockchainCertificate
} from 'src/core/helpers'

const SaleSmallDetails: React.FC<{ sale: BigSale }> = ({ sale }) => {
  const { t } = useTranslation()
  const status = getBigSaleStatus(sale)

  const saleStatus = {
    AWAITING_DOCS: { label: t('Transactions.AwaitingDocs'), type: 'default' },
    AWAITING_VALIDATION: { label: t('Transactions.AwaitingValidation'), type: 'default' },
    COMPLETED: { label: t('developers.Completed'), type: 'success' },
    CREDITS_COMMITTED: { label: t('Transactions.CreditsCommitted'), type: 'default' },
    CREDITS_IN_DELIVERY: { label: t('Transactions.CreditsInDelivery'), type: 'processing' },
    IN_REVIEW: { label: t('Transactions.InReview'), type: 'processing' },
    VALIDATED: { label: t('Transactions.Validated'), type: 'success' }
  }[status]

  const saleTotalAmount = getFormatedPrice(
    sale.supplierInvoiceTotalAmount ? sale.supplierInvoiceTotalAmount : sale.amount,
    sale.projectCurrencyCode
  )

  return <>
    <CustomTag text={saleStatus.label} type={saleStatus.type} />
    {sale.is_vintage && <CustomTag text={`${sale.vintageYear}`} type={'default'} />}

    <CustomTitle label={sale.projectName} level={null} type={null} className={styles.title} />
    <CustomTitle label={getDateFormatted(sale.created)} />
    <CustomTitle label={t('Transactions.TotalOrder', { orderTotal: saleTotalAmount })} type={null} />
    <br />
    <a target={'_blank'} rel='noopener noreferrer' href={getBigSaleBlockchainCertificate(sale)}>
      <Button
        type='primary'
        size='large'
        className={`${styles['btn-certificate']} radius-100`}
        icon={<CloudDownloadOutlined />}
      >
        {t('Transactions.BlockchainCertificate')}
      </Button>
    </a>
  </>
}

export default SaleSmallDetails
